export default __webpack_public_path__ + "static/media/spinner-gray.0f95be16.svg";